import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { Link } from 'react-router-dom'

import DataTable from '../../../DataTable'
import Button from '../../../../UniformComponents/Button'

@observer
class Search extends PureComponent {
    tableColumns = []

    componentDidMount() {
        const { store } = this.props
        this.setColumns()
        store.initSearch()
    }

    setColumns = () => {
        const { store } = this.props

        this.tableColumns = [
            {
                name: 'id',
                key: 'id',
            },
            {
                name: i18n.t('industry'),
                key: 'industry',
            },
            {
                name: i18n.t('product_type'),
                key: 'productType',
            },
            {
                name: i18n.t('survey_type'),
                key: 'surveyType',
            },
            {
                name: i18n.t('respondent_type'),
                key: 'respondentType',
            },
            {
                name: '',
                key: 'id',
                dataTransform: (id) => (
                    <Link style={{ fontSize: '22px' }} className="fal fa-edit" to={`/intranet/certification/${id}`} onClick={(e) => e.stopPropagation()} />),
            },
            {
                name: '',
                key: 'id',
                dataTransform: (id) => (
                    <i
                        style={{ fontSize: '22px' }}
                        className="fal fa-trash-alt"
                        onClick={(e) => {
                            e.stopPropagation()
                            store.delete(id)
                        }}
                    />
                ),
            },
        ]
    }

    renderDataTable = () => {
        const { history, store } = this.props
        const { searchData } = store

        const tableArgs = {
            data: searchData,
            columns: this.tableColumns,
            rowClick: (e, id) => { history.push(`/intranet/certification/${id}`) },
            rowId: 'id',
            emptyMessage: i18n.t('certification.search.noData'),
        }

        if (tableArgs.data.length > 0) {
            return (
                <DataTable
                    store={{ filteredList: tableArgs.data }}
                    dataSet={tableArgs.data}
                    columns={tableArgs.columns}
                    rowClick={tableArgs.rowClick}
                    rowId={tableArgs.rowId}
                    inMemory
                />
            )
        }
        return <div>{tableArgs.emptyMessage}</div>
    }

    goToNew = () => {
        const { history } = this.props
        history.push('/intranet/certification/0')
    }

    render() {
        const { store } = this.props
        const { isLoading } = store

        return (
            <div id="mergeFieldSearch" className="mergeFieldSearch">
                <div>
                    {!isLoading && (
                        <div className="panel">
                            <Button
                                type="button"
                                label={i18n.t('certification.search.new')}
                                onClick={this.goToNew}
                                cssClass="regular primary"
                            />
                            {this.renderDataTable()}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default Search
